import "./loader.css"

export function Loader () {
    return(
        <div className="loader-container">
            <div className="loader-spinner"></div>
        </div>
    )
}